import React from 'react';
import { motion } from 'framer-motion';

const ABOUT_IMAGE = "https://customer-assets.emergentagent.com/job_9eb43c1b-4d2e-4271-9c32-e74ba97db8fa/artifacts/5atbpdnk_AtreidesBullFighter.jpg";

const About = () => {
  return (
    <div data-testid="about-page" className="min-h-screen pt-24 md:pt-32 pb-24 bg-white">
      {/* Hero */}
      <section className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-20"
        >
          <span className="text-neutral-400 uppercase tracking-[0.2em] text-sm">
            Our Story
          </span>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight mt-2 text-black">
            About Tenome
          </h1>
        </motion.div>
      </section>

      {/* Story Section */}
      <section className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="order-2 lg:order-1"
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-black">
              Born From
              <br />
              Passion
            </h2>
            <p className="mt-8 text-neutral-500 text-lg leading-relaxed">
              Tenome was born from a deep love of cinema and the desire to bring 
              iconic movie moments into tangible art. What started as a personal 
              project has grown into a collection that celebrates the films and 
              series that have shaped our imagination.
            </p>
            <p className="mt-6 text-neutral-500 text-lg leading-relaxed">
              Each piece in our collection is meticulously designed and 3D printed, 
              then hand-finished to capture every detail. We believe that art should 
              tell a story, and our sculptures are chapters from the greatest stories 
              ever told on screen.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="order-1 lg:order-2"
          >
            <div className="aspect-square bg-black overflow-hidden">
              <img
                src={ABOUT_IMAGE}
                alt="Tenome Art"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 md:py-32 mt-24 bg-neutral-50">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <span className="text-neutral-400 uppercase tracking-[0.2em] text-sm">
              What Drives Us
            </span>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mt-2">
              <span className="text-[#e84628]">Our</span> Values
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: 'Craftsmanship',
                description: 'Every piece is crafted with meticulous attention to detail. We never compromise on quality.',
              },
              {
                title: 'Authenticity',
                description: 'Our designs stay true to the source material while adding our unique artistic perspective.',
              },
              {
                title: 'Passion',
                description: 'We are collectors ourselves. We create pieces that we would proudly display in our own homes.',
              },
            ].map((value, index) => (
              <motion.div
                key={value.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="p-8 bg-white border border-neutral-200 hover:border-black transition-colors"
              >
                <span className="text-neutral-300 text-sm">0{index + 1}</span>
                <h3 className="text-xl font-bold tracking-tight mt-4">
                  {value.title}
                </h3>
                <p className="mt-4 text-neutral-500 leading-relaxed">
                  {value.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-[#e84628] text-white">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight">
              <span className="text-white">Ready</span> to Start
              <br />
              Your Collection?
            </h2>
            <a
              href="/shop"
              className="inline-block mt-10 bg-white text-[#e84628] px-8 py-4 font-semibold uppercase tracking-wider hover:bg-neutral-100 transition-colors"
            >
              Explore Collection
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;
